import { DropDownOption } from '../interfaces/drop-down-option.interface';

export const INVESTMENT_LEVELS: DropDownOption[] = [
  {
    id: 'AT_BARRIER_LEVEL',
    displayValue: 'At Barrier Level',
  },
  {
    id: 'AT_CLOSE',
    displayValue: 'At Close',
  },
];
